module.exports = __webpack_public_path__ + "49bf5393aa98cdedef57c425f089b42d.svg";